export function buildObtenerDocumentosPorPaisResponse(obtenerDocumentoPorPaisResponse) {
    return {
        tipoDocumentoPaisDTOS: obtenerDocumentoPorPaisResponse.tipoDocumentoPaisDTOS,
        esRespOK: obtenerDocumentoPorPaisResponse.respuestaOk,
        respCodigo: obtenerDocumentoPorPaisResponse.codigoRespuesta,
        respMensaje: obtenerDocumentoPorPaisResponse.mensajeRespuesta,
    }
}